<template>
   <div class="p-grid">
		<div class="p-col-12">
			<div class="card p-shadow-1">
				<h5>Editar Usuário</h5>
                <hr>
                <TabView>					
                    <TabPanel header="Dados" class="p-mt-3">
                        <div class="p-fluid p-formgrid p-grid">
                            <div class="p-field p-col-12 p-md-4">
                                <label>Nome</label>
                                <InputText v-model="usuario.nome" required="true" autocomplete="off"/>
                            </div>                          
                        </div>
                        <div class="p-fluid p-formgrid p-grid">                     
                            <div class="p-field p-col-12 p-md-4">
                                <label>E-mail</label>
                                <InputText v-model.trim="usuario.email" autocomplete="off"/>
                            </div>                          
                        </div>
                        <div class="p-fluid p-formgrid p-grid">                           
                            <div class="p-field p-col-12 p-md-4">
                                <label>Perfil</label>
                                <Dropdown v-model="idPerfilSelecionado" :options="perfis" optionLabel="nome" optionValue="id"/>                         
                            </div> 
                        </div>
                    </TabPanel>
                    <TabPanel header="Empresas" class="p-mt-3">
                        <PickList v-model="cnpjsMat" listStyle="height:300px" dataKey="id" class="p-mb-3">
                            <template #sourceHeader>
                                Empresas Disponíveis
                            </template>
                            <template #targetHeader>
                                Empresas Selecionadas
                            </template>
                            <template #item="slotProps">
                                <div>
                                    {{slotProps.item.numero}} {{slotProps.item.razaoSocial}}
                                </div>
                            </template> 
                        </PickList> 
                    </TabPanel>
                    <TabPanel header="Centros de Custos" class="p-mt-3">
                        <div class="p-fluid p-formgrid p-grid">                           
                            <div class="p-field p-col-12 p-md-6">
                                <label>Empresa</label>
                                <Dropdown v-model="idCnpjSelecionado" :options="cnpjs" optionLabel="cnpjNome" optionValue="id" placeholder="Selecione" @change="listarCentrosCustos"/>                         
                            </div>                            
                        </div>
                        <PickList v-model="centrosCustos" listStyle="height:300px" dataKey="id" class="p-mb-3">
                            <template #sourceHeader>
                                Centros de Custos Disponíveis
                            </template>
                            <template #targetHeader>
                                Centros de Custos Selecionados
                            </template>
                            <template #item="slotProps">
                                {{slotProps.item.codigo}} - {{slotProps.item.nome}} ({{slotProps.item.tipo}})
                            </template> 
                        </PickList>
                    </TabPanel>
                </TabView> 
                <Button label="Fechar" class="p-button-secondary" icon="pi pi-times" @click="cancelar"/>
                <Button label="Salvar" class="p-ml-2" icon="pi pi-check" @click="salvar"/>  
            </div>
        </div>
    </div>
</template>

<script>
import UsuarioService from '@/service/UsuarioService';
import CentroCustoService from '@/service/CentroCustoService';
import { exibirMensagem, exibirMensagemSis, clonar} from '@/global';
import { mapGetters } from 'vuex';

export default {
    usuarioService: null,
    centroCustoService: null,  
    props: ['id'],
	data() {
		return {	
            idCnpjSelecionado: null,
            idPerfilSelecionado: null,            
            perfis: [],         
            usuario: {},
            cnpjsMat:[[], []],
            cnpjs: [],           
            centrosCustos:[[], []],
            centrosCustosUsuario: [],
		}
	},
	methods: {
        ...mapGetters('sessao', ['getDadosRequisicao','getPermissoes']),
        salvar() {
            if(this.usuario.nome == '' || this.usuario.email == '') {
                exibirMensagemSis(this, 'Informe nome e e-mail', true);
                return;
            }  
            let perfil = null;
            this.perfis.forEach(pf => {
                if(pf.id == this.idPerfilSelecionado) {
                    perfil = {...pf};
                }
            });
            let idsCentrosCustos = [];
            let idsCentrosCustosExcluir = [];
            let idsCnpjs = [];
            let idsCnpjsExcluir = [];
            this.centrosCustos[0].forEach(ct => {
                idsCentrosCustosExcluir.push(ct.id);
            });
            this.centrosCustos[1].forEach(ct => {
                idsCentrosCustos.push(ct.id);
            });
            this.cnpjsMat[0].forEach(cnpj => {
                idsCnpjsExcluir.push(cnpj.id);
            });
            this.cnpjsMat[1].forEach(cnpj => {
                idsCnpjs.push(cnpj.id);
            });
            let requisicao = {
                usuario: {...this.usuario},
                perfil: perfil,
                idsCentrosCustos: idsCentrosCustos,
                idsCentrosCustosExcluir: idsCentrosCustosExcluir,
                idsCnpjs: idsCnpjs,
                idsCnpjsExcluir: idsCnpjsExcluir,
                usuarioRequisicao: {...this.getDadosRequisicao()}
            }; 
            this.usuarioService.alterar(requisicao)
				.then(resp => {	
                    exibirMensagem(this, resp);
                    this.idCnpjSelecionado = null;
                    this.centrosCustos = [[], []];      
                    this.buscar();
                })
                .catch(erro => {exibirMensagem(this, erro)});
        },
		buscar() {
            let requisicao = {
                idUsuario: this.id,                   
                usuarioRequisicao: {...this.getDadosRequisicao()}
            }; 
			this.usuarioService.buscarEditar(requisicao)
				.then(resp => {		   
                    this.usuario = resp.data.usuario;                
                    this.cnpjsMat = [[],[]];
                    resp.data.cnpjs.forEach(cnpj => {
                        let encontrou = false;
                        resp.data.cnpjsUsuario.forEach(cnpjUsu => {                            
                            if(cnpj.id == cnpjUsu.id) {
                                encontrou = true;
                            }
                        }); 
                        if(!encontrou) {
                            this.cnpjsMat[0].push(cnpj);
                        } else {
                            this.cnpjsMat[1].push(cnpj);
                        }
                    });
                    this.cnpjs = resp.data.cnpjs;          
                    this.centrosCustosUsuario = resp.data.centrosCustosUsuario;                 
                    this.perfis = resp.data.perfis;
                    this.perfis.forEach(pf => {
                        if(pf.id == resp.data.perfil.id) {
                            this.idPerfilSelecionado = pf.id;
                        }
                    });                    
                })
                .catch(erro => {exibirMensagem(this, erro)});
        },  
        listarCentrosCustos() {
            let requisicao = {
                idCnpj: this.idCnpjSelecionado,                   
                usuarioRequisicao: {...this.getDadosRequisicao()}
            }; 
            this.centroCustoService.listarCentrosCustosUsuario(requisicao)
				.then(resp => {	                    
                    this.centrosCustos = [[], []];	
                    resp.data.forEach(ctc => {
                        let encontrou = false;
                        for(let i = 0; i < this.centrosCustosUsuario.length; i++) {
                            if(this.centrosCustosUsuario[i].id == ctc.id) {                                
                                this.centrosCustos[1].push(ctc);
                                encontrou = true;
                                break;
                            }
                        }
                        if(!encontrou) {                              
                            this.centrosCustos[0].push(ctc);
                        }
                    });                   
                })
                .catch(erro => {exibirMensagem(this, erro)});
        },        
        cancelar() {
            this.$router.push('/sistema/usuarios');
        }	        	
	},	
	created() {
        this.usuarioService = new UsuarioService();	
        this.centroCustoService = new CentroCustoService();		
	},
	mounted() {		
        this.buscar();
	}
}
</script>

<style>

</style>